export default __webpack_public_path__ + "static/media/28t.8b459247.jpg";